module.exports = __webpack_public_path__ + "img/logo.adf723ce.png";